import script from "./ContentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentCard.vue?vue&type=script&setup=true&lang=js"

import "./ContentCard.vue?vue&type=style&index=0&id=6b2cdfb8&lang=css"

const __exports__ = script;

export default __exports__